export default __webpack_public_path__ + "static/media/Icons_Power_Off Icon.d2438344.svg";